import { Label } from "@/components/ui/label";
import type { ServiceDetail } from "@/model/serviceDetails";
import { ExternalLink } from "lucide-react";
import PdfIcon from "@/assets/pdf-icon";
import COBALTDocumentIcon from "@/assets/COBALT-Document-Icon.svg";
import { CLIENT_NAME } from "@/lib/client-utils";

const Document = ({
  document,
  groupId,
}: {
  document: ServiceDetail;
  groupId: string;
}) => {
  return (
    <div className="min-w-68 relative min-h-60 rounded border bg-white p-4 text-center shadow-sm">
      <div className="absolute inset-x-1/2 top-12 flex w-full -translate-x-1/2 transform flex-col items-center justify-center gap-4">
        <div className="max-h-12 max-w-28">
          {groupId.startsWith(CLIENT_NAME.COBALT) ? (
            <img
              src={COBALTDocumentIcon}
              className="aspect-square object-contain"
              alt=""
            />
          ) : (
            <PdfIcon className="h-12 w-28 text-primary" />
          )}
        </div>

        <Label className="w-full text-[.875rem] font-semibold text-gray-600">
          {document?.serviceName}
        </Label>
      </div>

      <a
        href={`${document?.documentLink}`}
        target="_blank"
        className="absolute inset-x-1/2 bottom-3 flex min-w-40 -translate-x-1/2 transform items-center justify-center rounded bg-primary py-2 text-sm text-white no-underline hover:bg-primary-selected"
        rel="noreferrer"
      >
        <ExternalLink className="mr-2" size={12} />
        <span>View Document</span>
      </a>
    </div>
  );
};

export default Document;
